
// stupid me ... see const in RecurrenceManagerProto as well..
// should be entitytype ... heh... what can I do now ? :-/
export const TASK_RECURRENCE = 'task'
export const MEETING_RECURRENCE = 'meeting'
export const EVENT_RECURRENCE = 'event'
export const REMINDER_RECURRENCE = 'reminder'